import React from "react";
import Layout from "../components/layout";
import Container from "../components/layout/container";

export default function AboutPage() {
  return (
    <Layout>
      <main className="py-12 sm:py-16">
        <Container>
          <div className="mx-auto max-w-2xl text-center">
            <h1 className="text-3xl sm:text-4xl font-black text-black/85">
              About Retro Revive
            </h1>

            <p className="mt-4 text-sm leading-relaxed text-black/60">
              Retro Revive is a nostalgia-inspired gift shop focused on
              old-fashioned, meaningful gifts. We believe the best gifts are not
              loud or trendy — they are personal, emotional, and timeless.
            </p>

            <p className="mt-4 text-sm leading-relaxed text-black/60">
              From memory jars and mini photo albums to romantic roses and
              handcrafted décor, each item is designed to preserve moments,
              feelings, and stories that matter.
            </p>

            <p className="mt-4 text-sm font-semibold text-black/70">
              Retro Revive is where memories are gifted, not forgotten.
            </p>
          </div>
        </Container>
      </main>
    </Layout>
  );
}
